(() => {
  const form = document.getElementById('NovaraLocalization');
  form?.addEventListener('submit', () => {
    let returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.append(returnTo);
    }
    returnTo.value = location.pathname + location.search + location.hash;
  });
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  if (root === '/') return;
  const localizeLinks = scope => {
    for (const link of scope.querySelectorAll('a[href]')) {
      const href = link.getAttribute('href');
      if (/^\/(?:products|collections|pages|cart)(?:[/?#]|$)/.test(href)) {
        link.setAttribute('href', root + href.slice(1));
      }
    }
  };
  localizeLinks(document);
  for (const target of [document.getElementById('main'), document.getElementById('bag-content')].filter(Boolean)) {
    new MutationObserver(() => localizeLinks(target)).observe(target, {childList:true, subtree:true});
  }
})();
